import { Outlet } from 'react-router-dom';
import { LogoWordmark } from '@teivor/shared-ui';

export function AuthLayout() {
  return (
    <div className="flex min-h-[100dvh] flex-col bg-[var(--color-bg)] text-[var(--color-fg)]">
      <header className="flex justify-center pt-10">
        <LogoWordmark height={32} />
      </header>
      <main id="main" className="flex flex-1 items-center justify-center px-4 py-8">
        <div className="w-full max-w-md rounded-[var(--radius-lg,12px)] border border-[var(--color-border)] bg-[var(--color-surface)] p-6 shadow-[var(--shadow-md,0_4px_24px_rgba(0,0,0,0.06))] md:p-8">
          <Outlet />
        </div>
      </main>
      <footer className="pb-6 text-center text-xs text-[var(--color-fg-muted)]">
        &copy; {new Date().getFullYear()} Teivor
      </footer>
    </div>
  );
}
